import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-common-header',
  templateUrl: './common-header.component.html',
  styleUrls: ['./common-header.component.css']
})
export class CommonHeaderComponent implements OnInit {

  @Input() id: string;
  @Input() title: string;
  @Input() backUrl: string;

  constructor() { }

  ngOnInit() {
  }

}
